export type DataDogClickSourceType = 'watchlist';
export type DataDogClickMediumType = 'email';
export type DataDogClickTypeType = 'job' | 'dhl';

export const DATA_DOG_CLICK_SOURCE_TYPES: DataDogClickSourceType[] = ['watchlist'];
export const DATA_DOG_CLICK_MEDIUM_TYPES: DataDogClickMediumType[] = ['email'];
export const DATA_DOG_CLICK_TYPE_TYPES: DataDogClickTypeType[] = ['job', 'dhl'];
